import { render, staticRenderFns } from "./ClientRewriteComponent.vue?vue&type=template&id=661ca524&scoped=true&"
import script from "./ClientRewriteComponent.vue?vue&type=script&lang=js&"
export * from "./ClientRewriteComponent.vue?vue&type=script&lang=js&"
import style0 from "./ClientRewriteComponent.vue?vue&type=style&index=0&id=661ca524&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661ca524",
  null
  
)

export default component.exports